'use client';

import { useHostMode, useHostType } from '@repo/host/hooks/use-host-info';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsMobileViewport } from '@repo/store/maps/slices/clientContext';
import { selectIsInCreatorMode } from '@repo/store/maps/slices/mapData';
import type React from 'react';
import { isStandaloneWebMapHost } from '../utils/is-standalone-web-map-host';
export const MapSidebarAdShell = t0 => {
  const {
    children
  } = t0;
  const hostType = useHostType();
  const hostMode = useHostMode();
  const isInCreatorMode = useAppSelector(selectIsInCreatorMode);
  const isMobileViewport = useAppSelector(selectIsMobileViewport);
  if (!isStandaloneWebMapHost(hostType, hostMode) || isInCreatorMode || isMobileViewport) {
    return null;
  }
  return children;
};